import React, { useState, useEffect } from "react";

export default function BankTile({
  logo,
  logoUrl,
  name,
  accountNumber,
  allowRemove = true,
  disabled = false,
  handleRemove = () => {},
  triggerOnHover = true,
  showWarning = false,
  warningAction = () => {},
  dashboard
}) {
  const [hovered, setHovered] = useState(false);
  const [buttonHovered, setButtonHovered] = useState(false);
  const [showDeleteButton, setShowDeleteButton] = useState(false);

  useEffect(() => {
    if (triggerOnHover) {
      setShowDeleteButton(hovered);
    }
  }, [hovered]);

  return (
    <div
      className={`shadow mb-2 ${allowRemove && !disabled && "cursor-pointer"}`}
      style={{
        background: disabled ? "#ececec" : "#FFFFFF",
        color: disabled ? "lightgray" : "#99B5B7",
      }}
    >
      <div
        className="flex w-full"
        onMouseEnter={(e) => {
          if (!disabled) setHovered(true);
        }}
        onMouseLeave={(e) => {
          setHovered(false);
          setShowDeleteButton(false);
        }}
        onClick={() => {
          if (!disabled) setShowDeleteButton(true);
        }}
      >
        {showWarning ? (
          <div
            className="flex hover:bg-gray-100 border-r border-gray-200"
            onClick={warningAction}
          >
            <i className="far fa-exclamation-circle text-xl text-red-500 self-center px-4"></i>
          </div>
        ) : (
          <></>
        )}
        <div className="flex flex-1 justify-between">
          <img
            src={
              logo
                ? `data:image/png;base64,${logo}`
                : logoUrl
                ? `${logoUrl}`
                : "data:image/gif;base64,R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="
            }
            className="p-2 self-center pl-4"
            style={{
              ...(dashboard ? { height: 45 } : { height: 30 }),
            }}
          ></img>
          <p className="pr-4 self-center text-xs sm:text-sm font-light">
            {name} {`(**${accountNumber})`}
          </p>
        </div>
        <div
          className="bg-gray-200"
          style={{
            width: showDeleteButton ? 1 : 0,
          }}
        ></div>
        <div
          className={`self-center overflow-hidden ${
            allowRemove ? "" : "cursor-not-allowed"
          }`}
          style={{
            width: showDeleteButton ? "3em" : 0,
            transition: "width 0.3s",
          }}
          onClick={!disabled && handleRemove}
          onMouseEnter={(e) => {
            setButtonHovered(true);
          }}
          onMouseLeave={(e) => {
            setButtonHovered(false);
          }}
        >
          <div
            className={`py-3 mx-2 ${(buttonHovered || !triggerOnHover) &&
              !disabled &&
              allowRemove &&
              "text-red-600"}`}
          >
            <i className="far fa-trash-alt"></i>
          </div>
        </div>
      </div>
    </div>
  );
}
